<template>
  <div id="BoxMenu">

    <div class="wrapper">
      <!--
        <li class="menu-item" @click="navbtn = 'centrala'">
          <router-link :class="[($route.path.replace('/','') === '') ? 'activeNav' : '']" to="/">Centrala / moduł</router-link>
        </li>
        <li class="menu-item" @click="navbtn = 'obudowa'">
          <router-link :class="[($route.path.replace('/','').indexOf('dopasuj-centrale') > -1) ? 'activeNav' : '']" to="/dopasuj-centrale">Obudowa</router-link>
        </li>
      -->

      <router-link class="btnBox" :to="{ name: 'DopasujObudowe', params: { page: 'DopasujObudowe' }}" exact>
        <div class="card card-2">
          <h4 v-html="$t('message.dopasowanie_obudowy')"></h4>
          <div class="ikonka"><img src="../assets/icon_centrala_obudowa.png"/></div>
          <div class="statystyki">
          </div>
        </div>

      </router-link>

      <router-link class="btnBox" :to="{ name: 'DopasujCentrale', params: { page: 'DopasujCentrale' }}">
        <div class="card card-1">
          <h4 v-html="$t('message.dopasowanie_centrali')"></h4>
          <div class="ikonka"><img src="../assets/icon_obudowa_centrala.png"/></div>
          <div class="statystyki">
          </div>
        </div>
      </router-link>

    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BoxMenu',
  // props: ['userData', 'roles'],
  data () {
    return {
    }
  },
  computed: {
    // ...mapState('app', ['statystyki']),
    // statistics_orders () {
    //   return Object.keys(this.statystyki).length
    // }
  },
  methods: {
    // get_statistic_orders () {
    //   this.$store.dispatch('app/get_statystyki_dzialu', 'obudowy')
    // }
  },
  created () {
    // sessionStorage.setItem('grupa', '')
    // sessionStorage.setItem('add', '')
    // sessionStorage.setItem('edit', '')
    // sessionStorage.setItem('this', 'obudowyHomePage')
    // sessionStorage.setItem('back', '')
    // sessionStorage.setItem('pulsar', '')
    // sessionStorage.setItem('modul', 'obudowy')
    // this.get_statistic_orders()
  }
}
</script>

<style scoped>
#BoxMenu {
  max-width: 665px;
  margin: 30px auto;
}
.wrapper {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  border: 0px solid black;
  width: 100%;
  max-width: 1115px;
  margin: 0px auto;
}
.card {
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  width: 310px;
  height: 290px;
  margin: 10px;
  color: #fff;
  font-size: 36px;
  font-weight: 600;
  border: 0px solid rgba(0, 0, 0, 0.125);
  border-radius: 0rem;
  transition: transform .3s, box-shadow .3s;
}
.card:hover {
  transform: scale(1.05);
  box-shadow: 0px 0px 8px black;
  z-index: 9999;
}
.card h4 {
font-size: 20px;
margin: 0px;
padding: 6px;
font-weight: 500;
text-align: left;
}

.ikonka img {
  width: 230px;
}

.statystyki {
  font-size: 12px;
  position: absolute;
  bottom: 0px;
  height: 40px;
  width: 100%;
}
.statystyki ul {
  list-style: none;
  /* width: 100%; */
  width: 50%;
  height: 100%;
  padding: 0px;
  float: left;
}
.statystyki ul li {
  /* width: 50%; */
  width: 100%;
  float: left;
  padding-left: 15px;
  text-align: left;
  height: 18px;
}
.statystyki ul li:nth-child(2){
  /* width: 50%; */
  width: 100%;
  float: left;
  padding-left: 15px;
  text-align: left;
}
.statystyki ul.ul-right li  {
  padding-left: 0px;
  text-align: right;
  padding-right: 15px;
}
.btnBox{
  text-decoration: none !important;
}
.card-1 {
  background-image: linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(29,139,253,1) 100%);
}
.card-2 {
  background-image: linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(24,168,60,1) 100%);
}
</style>



// WEBPACK FOOTER //
// src/components/BoxMenu.vue